const burgarDetails = [
  {
    id: 1,
    burgarName: "The Bun Jovi.",
    burgarImg: "https://source.unsplash.com/_qxbJUr9RqI",
    price: 450,
    delivaryTime: 3,
    rating: 4.5,
  },
  {
    id: 2,
    burgarName: "Burger N' Bite.",
    burgarImg: "https://source.unsplash.com/uVPV_nV17Tw",
    price: 400,
    delivaryTime: 3,
    rating: 4,
  },
  {
    id: 3,
    burgarName: "The IceBurg.",
    burgarImg: "https://source.unsplash.com/CK6tjAIMJWM",
    price: 500,
    delivaryTime: "Fast",
    rating: 3.5,
  },
  {
    id: 4,
    burgarName: "The Grill Thrill.",
    burgarImg: "https://source.unsplash.com/jh5XyK4Rr3Y",
    price: 300,
    delivaryTime: 4,
    rating: 5,
  },
  {
    id: 5,
    burgarName: "Burger Mania.",
    burgarImg: "https://source.unsplash.com/8l8Yl2ruUsg",
    price: 800,
    delivaryTime: 2,
    rating: 2,
  },
  {
    id: 6,
    burgarName: "Chicha Burger.",
    burgarImg: "https://source.unsplash.com/PxJ9zkM2wdA",
    price: 350,
    delivaryTime: 3,
    rating: 3.5,
  },
  {
    id: 7,
    burgarName: "Burger Buzz.",
    burgarImg: "https://source.unsplash.com/OvNsLemoVEw",
    price: 200,
    delivaryTime: "Fast",
    rating: 3,
  },
  {
    id: 8,
    burgarName: "Friendly Burger.",
    burgarImg: "https://source.unsplash.com/88YAXjnpvrM",
    price: 700,
    delivaryTime: 3,
    rating: 1,
  },
  {
    id: 9,
    burgarName: "Five Guys' bacon cheeseburger.",
    burgarImg: "https://source.unsplash.com/JqnuWlHmDfE",
    price: 700,
    delivaryTime: 5,
    rating: 4.5,
  },
  {
    id: 10,
    burgarName: "Steak 'N Shake Double 'N Cheese Steakburger Steak N Shake.",
    burgarImg: "https://source.unsplash.com/LV2p9Utbkbw",
    price: 500,
    delivaryTime: "Fast",
    rating: 5,
  },
];

export default burgarDetails;
